import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles(() => ({
    scroll: { overflowX: 'auto', maxHeight: 'calc(100vh - 330px)' },
    numeric: { textAlign: 'right', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' },
    total: { fontWeight: 600 },
    date: { whiteSpace: 'nowrap', fontWeight: 500 },
}));
